/* istanbul ignore file */
import { createAction, createReducer } from '@reduxjs/toolkit';
import { SISTEMAS_E_SEFAZ_USUARIO } from 'utils/consts';

const INITIAL_STATE = {
  allSystems: JSON.parse(localStorage.getItem(SISTEMAS_E_SEFAZ_USUARIO)) || [],
  userProfile: null,
};

export const duckTodosSistemas = createAction('DUCK_SEFAZ_AUTH_TODOS_SISTEMAS');
export const duckUserProfile = createAction('DUCK_SEFAZ_AUTH_USER');

export default createReducer(INITIAL_STATE, {
  [duckTodosSistemas.type]: (state, action) => ({
    ...state,
    allSystems: action.payload,
  }),
  [duckUserProfile.type]: (state, action) => ({
    ...state,
    userProfile: action.payload,
  }),
});
